import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=2cb28502&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.vue?vue&type=style&index=0&id=2cb28502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb28502",
  null
  
)

export default component.exports